const __WEBPACK_NAMESPACE_OBJECT__ = SharedDependencies.MobX['application-83abc821'];